import { createSlice } from "@reduxjs/toolkit";
import { Asset } from "../models/Asset";

const AssetInitialState: {
	areasList: Asset[];
	allAssets: Asset[];
} = {
	areasList: [],
	allAssets: [],
};

export const AssetReducer = createSlice({
	name: "__",
	initialState: AssetInitialState,
	reducers: {
		setAreasList(state, { payload }) {
			state.areasList = payload;
		},
		setAllAssets(state, { payload }) {
			state.allAssets = payload;
		},
	},
});
